export default "__VITE_ASSET__U_fkZyai__"